import { Center, Menu, Portal, Text } from '@chakra-ui/react';
import { AddPulsIcon, ContactsIcon, GroupMemberIcon } from '@halo/ui-chat-react';
import { useActionsStore } from '@/store/actions';

export interface AddOperationsProps {
  isMiniNav: boolean;
}

export function AddOperations({ isMiniNav }: AddOperationsProps) {
  const { t } = useTranslation();
  const setGroupCreateIsOpen = useActionsStore((store) => store.setGroupCreateIsOpen);
  const setContactsAddIsOpen = useActionsStore((store) => store.setContactsAddIsOpen);

  return (
    <>
      <Menu.Root positioning={{ placement: isMiniNav ? 'right-start' : 'right-start' }}>
        <Menu.Trigger asChild>
          <Center p="1" cursor="pointer" color="fg" fontSize="lg">
            <AddPulsIcon className="shake" />
          </Center>
        </Menu.Trigger>
        <Portal disabled>
          <Menu.Positioner>
            <Menu.Content
              w="auto"
              minW="186px"
              p="1"
              borderRadius="lg"
              backdropFilter="blur(6px)"
              bg="whiteAlpha.70"
            >
              <Menu.Item
                value="add-contact"
                gap="2.5"
                py="3"
                px="2"
                borderRadius="sm"
                cursor="pointer"
                _hover={{ bg: 'bg.muted' }}
                onClick={() => setContactsAddIsOpen(true)}
              >
                <Center fontSize="lg">
                  <ContactsIcon />
                </Center>
                <Text fontSize="sm" fontWeight="semibold">
                  {t('action.addContact')}
                </Text>
              </Menu.Item>
              <Menu.Item
                value="new-group"
                gap="2.5"
                py="3"
                px="2"
                borderRadius="sm"
                cursor="pointer"
                _hover={{ bg: 'bg.muted' }}
                onClick={() => setGroupCreateIsOpen(true)}
              >
                <Center fontSize="lg">
                  <GroupMemberIcon />
                </Center>
                <Text fontSize="sm" fontWeight="semibold">
                  {t('action.newGroup')}
                </Text>
              </Menu.Item>
            </Menu.Content>
          </Menu.Positioner>
        </Portal>
      </Menu.Root>
    </>
  );
}
